// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AccountAppsImportSchema } from './v1/accountApps/importSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const createsAppUserImportJobPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_user_id: z.number().int().describe("AppUser id"),
});

export const createsAppUserImportJobHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description import job created
 */
export const createsAppUserImportJob204Schema = z.unknown();

/**
 * @description AppUser not found
 */
export const createsAppUserImportJob404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const createsAppUserImportJobMutationRequestSchema = z.lazy(() => v1AccountAppsImportSchema);

export const createsAppUserImportJobMutationResponseSchema = z.lazy(() => createsAppUserImportJob204Schema);
